var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPreviewLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 16.6666C6.31777 16.6666 3.33301 13.6818 3.33301 9.99998C3.33301 6.31808 6.31777 3.33331 9.99967 3.33331C13.6815 3.33331 16.6663 6.31808 16.6663 9.99998C16.6663 13.6818 13.6815 16.6666 9.99967 16.6666ZM9.99967 15.3333C12.9452 15.3333 15.333 12.9455 15.333 9.99998C15.333 7.05446 12.9452 4.66665 9.99967 4.66665C7.05415 4.66665 4.66634 7.05446 4.66634 9.99998C4.66634 12.9455 7.05415 15.3333 9.99967 15.3333ZM9.08094 7.60971L12.3335 9.77811C12.4561 9.85978 12.4892 10.0254 12.4075 10.1479C12.3879 10.1772 12.3628 10.2023 12.3335 10.2218L9.08094 12.3902C8.95841 12.472 8.79281 12.4388 8.71114 12.3163C8.68194 12.2725 8.66634 12.221 8.66634 12.1684V7.83159C8.66634 7.68431 8.78574 7.56492 8.93301 7.56492C8.98567 7.56492 9.03714 7.5805 9.08094 7.60971Z",
    fill: "#FC6328"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPreviewLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/preview-line.1f88019e.svg";
export { ForwardRef as ReactComponent };